import { render } from "./BlogPage.vue?vue&type=template&id=cb22c11e"
import script from "./BlogPage.vue?vue&type=script&lang=js"
export * from "./BlogPage.vue?vue&type=script&lang=js"

import "./BlogPage.vue?vue&type=style&index=0&id=cb22c11e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__